import { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@rtkwlf/pro-solid-svg-icons/faCog';
import { useTranslation } from 'react-i18next';

import { signout } from '@platform/client/auth/signout';
import { useGetUserInfo } from '@platform/client/auth/use-get-user-info';

import { Divider } from '@packages/fenrir/components/divider';
import { IconButton } from '@packages/fenrir/components/icon-button';
import { ListItemText, ListSubheader } from '@packages/fenrir/components/list';
import { Menu } from '@packages/fenrir/components/menu';
import { MenuItem } from '@packages/fenrir/components/menu-item';
import { Tooltip } from '@packages/fenrir/components/tooltip';
import { styled } from '@packages/fenrir/styles';

import { ThemeMenuItems } from './theme-menu-items';
import { TimezoneMenuItems } from './timezone-menu-items';

// TODO: @evagm: Move into Fenrir
const MenuSubheader = styled(ListSubheader)(({ theme }) => ({
  ...theme.typography.caption,
  backgroundColor: 'transparent',
}));

export const SettingsMenu = () => {
  const { t } = useTranslation('app', { keyPrefix: 'appBar.settingsMenu' });
  const user = useGetUserInfo();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {/* tooltip title adds an aria-label on the children tag */}
      <Tooltip title={t('title')}>
        <IconButton
          id="appbar-settings-menu"
          size="small"
          onClick={handleClick}
        >
          <FontAwesomeIcon icon={faCog} />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'appbar-settings-menu',
            dense: true,
          },
        }}
      >
        {/* A Divider is required between the each grouping to remain accessible */}
        <MenuSubheader>{t('appearance')}</MenuSubheader>
        <ThemeMenuItems handleCloseMenu={handleClose} />
        <Divider />
        <MenuSubheader>{t('displayTime')}</MenuSubheader>
        <TimezoneMenuItems handleCloseMenu={handleClose} />
        <Divider />
        <MenuSubheader>{user?.email}</MenuSubheader>
        <MenuItem onClick={() => signout()}>
          <ListItemText>{t('signout')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
